import React from "react";
import logoPng from "../../../assets/logo.png";
import { LOGIN_ROUTE } from "constants/routes";
import Button from "components/shared-ui/button";
import styles from "./logout-success-page.module.scss";

function LogoutSuccessPage() {

    return (
        <div className={styles["data-wrapper"]}>
            <img src={logoPng} alt="logo" className={styles.logo} />

            <h1>You have been successfully logged out.</h1>

            <Button
                colors="primary"
                href={LOGIN_ROUTE}
                testId="login-button"
                className={styles["login-button"]}
            >
                Log In
            </Button>
        </div>
    );
}

export default LogoutSuccessPage;